import React, {Fragment, useMemo} from "react"
import {CheckoutDataSection, CheckoutSubMainSection} from "../../models"
import {DataForm} from "./DataForm"
import {
  BasketResponse,
  BasketTypeEnum,
  CheckoutRequest,
  GetBasketResponseItem,
  ProductTypeEnum
} from "@jnext/ts-axios-formatdigitalcollection"
import {getProductImage} from "@jnext/commons"
import {FORMAT_DATE, generatePathUrl, useTranslationWord} from "../../../../utils"
import {ProductType} from "../../../../enums/ProductType"
import i18n, {t} from "i18next"
import moment from "moment/moment"

interface BasketItemProps {
  item: GetBasketResponseItem;
}

const BasketItem: React.FC<BasketItemProps> = ( {item} ) => {
  const translateWord = useTranslationWord()
  const productImg = getProductImage(item?.cms)

  if (item.productType === ProductTypeEnum.Service) {
    return <div className={"cart-product"}>
      <div className={`product-data ${!productImg ? "not-border" : ""}`}>
        <div className={`left-side ${!productImg ? "not-padding" : ""}`}>
          <div className={"product-name"}>{translateWord("SUBSCRIPTION_TEXT", {service: item?.cms?.title})}</div>
        </div>
        <div className={"right-side"}>
        </div>
      </div>

    </div>
  }

  return <div className={"cart-product"}>
    {
      productImg &&
      <figure className={"img-container"}>
        <img src={generatePathUrl(productImg)} alt={""} aria-hidden={true} />
      </figure>
    }
    <div className={`product-data ${!productImg ? "not-border" : ""}`}>
      <div className={`left-side ${!productImg ? "not-padding" : ""}`}>
        <div className={"brand-name"}>{item?.brands?.[0]?.title}</div>
        <div className={"product-name"}>{item?.cms?.title}</div>
      </div>
      <div className={"right-side"}>
      </div>
    </div>

  </div>
}

interface DataFormProps {
  onComplete: ( checkoutRequest: CheckoutRequest ) => void;
  cmsConfig: CheckoutSubMainSection;
  initiativeLogicId: string;
  basketType: BasketTypeEnum;
  basket: BasketResponse;
  initialValues: CheckoutRequest|undefined;
  showDeliveryDaysInfo?: boolean;
  genericDeliveryDays?: number,
  options?: Record<string, string>;
}

export const DataFormContainer: React.FC<DataFormProps> = ( {
                                                              onComplete,
                                                              cmsConfig,
                                                              initiativeLogicId,
                                                              basketType,
                                                              basket,
                                                              initialValues,
                                                              showDeliveryDaysInfo = false,
                                                              genericDeliveryDays,
                                                              options
                                                            } ) => {

  const isDirectPurchase = useMemo(() => basketType == BasketTypeEnum.DirectPurchase, [basketType])
  const translateWord = useTranslationWord()
  const shipments = basket?.shipments?.[0]
  const checkoutDescriptionAction = i18n.exists("checkoutDescriptionAction") ? t("checkoutDescriptionAction") : ""
  const servicePurchased = useMemo(() => sessionStorage.getItem("servicePurchased") === "true", [sessionStorage])

  return (
    <>
      <div className={`data-form-step ${isDirectPurchase ? "direct-purchase" : ""}`}>

        {
          // isDirectPurchase && basket?.items &&
          isDirectPurchase && shipments?.items &&
          <div className={"cart-items"}>

            {
              showDeliveryDaysInfo &&

              <Fragment>
                {
                  (shipments?.productType ?? (ProductTypeEnum.Item as string)) === ProductType.PHYSICAL
                  &&
                  <p className={"delivery_description"}>
                    <strong>
                      {shipments?.deliveryDays ? translateWord("deliveryDaysCartConfirm", {count: shipments?.deliveryDays}) : translateWord("deliveryDaysCartConfirmGeneric", {count: genericDeliveryDays})}
                    </strong>
                  </p>
                }

                {
                  (shipments?.productType ?? ProductTypeEnum.Voucher) === ProductTypeEnum.Voucher
                  &&
                  <p className={"delivery_description"}>
                    <strong>
                      {translateWord("deliveryDaysCartConfirm_vouchers")}
                    </strong>
                  </p>
                }
              </Fragment>

            }

            <BasketItem item={shipments?.items?.[0]} />
          </div>
        }


        <div className={"form-container"}>
          <DataForm
            cmsConfig={cmsConfig as CheckoutDataSection}
            onComplete={onComplete}
            initiativeLogicId={initiativeLogicId}
            basket={basket}
            initialValues={initialValues}
            options={options}
          />

          {servicePurchased && shipments?.productType === ProductTypeEnum.Service &&
            <label
              dangerouslySetInnerHTML={{__html: checkoutDescriptionAction}}
            />}

          {shipments?.productType !== ProductTypeEnum.Service && !options?.hideRequiredDisclaimer &&
            <label className={"required_disclaimer"}>{translateWord("REQUIRED_FIELDS_DISCLAIMER")}</label>}
        </div>
      </div>
    </>
  )
}